import React from 'react';
import { Tag } from 'pounceV2';

interface ManagedBadgeProps {
  managed: boolean;
}
const ManagedBadgeV3: React.FC<ManagedBadgeProps> = ({ managed }) => {
  let badgeText;
  let badgeVariant;
  if (managed) {
    badgeVariant = 'success';
    badgeText = 'Managed';
  } else {
    badgeVariant = 'error';
    badgeText = 'Unmanaged';
  }
  return (
    <Tag variant={badgeVariant} selected>
      {badgeText}
    </Tag>
  );
};

export default ManagedBadgeV3;
